import template from './sw-cms-preview-acris-blog-content.html.twig';
import './sw-cms-preview-acris-blog-content.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-content', {
    template
});
